export const GET_INVOICE_CODES_QUERY = `
  query GetInvoiceCodes($where: invoice_codes_bool_exp) {
    invoice_codes(where: $where, order_by: { created_at: desc }) {
      id
      code_name
      product_name
      description
      company_id
      created_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_INVOICE_CODES_BY_ID_QUERY = `
  query GetInvoiceCodeById($id: Int!) {
    invoice_codes_by_pk(id: $id) {
      id
      code_name
      product_name
      description
      company_id
      created_at
    }
  }
`;